import { Link } from "react-router-dom";
import { downloadHref } from "../../config/stores";
import { trackCta } from "../../utils/tracking";

// A "Get the app" link that goes to the right store for this device: Google Play on
// Android, the App Store (or the waitlist before launch) on iPhone, and the /download page
// with a QR code on a computer.
export default function GetAppLink({ placement, className = "", children }) {
    const href = downloadHref(placement);
    const onClick = () => trackCta(placement, { cta_label: "get_app" });
    if (href.startsWith("/")) {
        return (
            <Link to={href} className={className} onClick={onClick}>
                {children}
            </Link>
        );
    }
    return (
        <a href={href} className={className} onClick={onClick} rel="noopener noreferrer">
            {children}
        </a>
    );
}
